import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useWatch } from 'react-hook-form';
import type { ChildrenFormGroupData } from '../../FormData.dk.types';
import {
  amountOfChildrenOptions,
  childrenAgeOptions,
} from '../../config/globals';
import { requiredField, requiredUnregisterField } from '../shared-config';

export function ChildrenFormGroup() {
  const { t } = useTranslation();

  const amountOfChildren = Number(
    useWatch({ name: 'Frontend/AmountOfChildren', defaultValue: 0 })
  );

  const childrenAgeInputs = Array.from({ length: amountOfChildren }).map(
    (_, index) => (
      <RadioFieldUI<ChildrenFormGroupData>
        key={`child-${index}`}
        name={`Child/${index}/Age`}
        label={t('Child.Age.label', { index: index + 1 })}
        data-testid={`age-of-child-${index}-radio`}
        radioStyle="button"
        options={childrenAgeOptions}
        registerOptions={requiredUnregisterField}
      />
    )
  );

  return (
    <>
      <RadioFieldUI<ChildrenFormGroupData>
        name="Frontend/AmountOfChildren"
        label={t('AmountOfChildren.label')}
        data-testid="number-of-children-radio"
        radioStyle="button"
        options={amountOfChildrenOptions}
        registerOptions={requiredField}
        shouldTouch
      />

      {childrenAgeInputs}
    </>
  );
}
